import './App.css';

function App() {
  return (
    <div className="App">
      <h1>Welcome to SMS Gateway</h1>
      <p>This is your SMS management portal</p>
      {/* You'll add more components here later */}
    </div>
  );
}

export default App;